import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

// Effort FollowUp API Methods
export const followUpService = {
  // Get all follow-up for a specific effort
  getFollowUp: async (effortId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/business/efforts/${effortId}/follow-up/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching follow-up:", error);
      throw error;
    }
  },

  // Create a new followUp for an effort
  createFollowUp: async (effortId, followUpData) => {
    try {
      const payload = {
        date: followUpData.date,
        follow_up: followUpData.followUp,
      };

      const response = await axios.post(
        `${baseUrl}/api/business/efforts/${effortId}/follow-up/`,
        payload,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating followUp:", error);
      throw error;
    }
  },

  // Update an existing followUp
  updateFollowUp: async (effortId, followUpId, followUpData) => {
    try {
      const payload = {
        date: followUpData.date,
        follow_up: followUpData.followUp,
      };

      const response = await axios.put(
        `${baseUrl}/api/business/efforts/${effortId}/follow-up/${followUpId}/`,
        payload,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating followUp:", error);
      throw error;
    }
  },

  // Delete a followUp
  deleteFollowUp: async (effortId, followUpId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/business/efforts/${effortId}/follow-up/${followUpId}/`,
        getConfig()
      );
      return response.status === 204;
    } catch (error) {
      console.error("Error deleting followUp:", error);
      throw error;
    }
  },

  // Milestone-related methods
  milestones: {
    // Get milestones for a specific followUp
    getMilestones: async (effortId, followUpId) => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/business/efforts/${effortId}/follow-up/${followUpId}/milestones/`,
          getConfig()
        );
        return response.data.data;
      } catch (error) {
        console.error("Error fetching milestones:", error);
        throw error;
      }
    },

    // Add a new milestone to a followUp
    createMilestone: async (effortId, followUpId, milestoneData) => {
      try {
        const payload = {
          followUp: followUpId,
          where: milestoneData.where,
          what: milestoneData.what,
          host: milestoneData.host,
          link: milestoneData.link,
        };

        const response = await axios.post(
          `${baseUrl}/api/business/efforts/${effortId}/follow-up/${followUpId}/milestones/`,
          payload,
          getConfig()
        );
        return response.data.data;
      } catch (error) {
        console.error("Error creating milestone:", error);
        throw error;
      }
    },

    // Update an existing milestone
    updateMilestone: async (
      effortId,
      followUpId,
      milestoneId,
      milestoneData
    ) => {
      try {
        const payload = {
          where: milestoneData.where,
          what: milestoneData.what,
          host: milestoneData.host,
          link: milestoneData.link,
          additional_info: milestoneData.additionalInfo,
        };

        const response = await axios.put(
          `${baseUrl}/api/business/efforts/${effortId}/follow-up/${followUpId}/milestones/${milestoneId}/`,
          payload,
          getConfig()
        );
        return response.data.data;
      } catch (error) {
        console.error("Error updating milestone:", error);
        throw error;
      }
    },

    // Delete a milestone
    deleteMilestone: async (effortId, followUpId, milestoneId) => {
      try {
        const response = await axios.delete(
          `${baseUrl}/api/business/efforts/${effortId}/follow-up/${followUpId}/milestones/${milestoneId}/`,
          getConfig()
        );
        return response.status === 204;
      } catch (error) {
        console.error("Error deleting milestone:", error);
        throw error;
      }
    },
  },
};

export default followUpService;
